import React from 'react'
import styles from './FormHeaderOverlay.module.css'

type FormHeaderOverlayProps = {
    isVisible: boolean
    onDismiss: () => void
}

export const FormHeaderOverlay = ({ isVisible, onDismiss }: FormHeaderOverlayProps) => {
    if (!isVisible) return null

    return (
        <div
            className={styles.overlay}
            onClick={onDismiss}
            aria-hidden="true"
        />
    )
}
